import { VIEW_ROUTE_PATH } from '@/constants/routes'

export default function checkViewSession({ to, store, next }) {
  const { isViewSession } = store.getters
  const { params, query, path } = to
  const isViewRoute = path.startsWith(VIEW_ROUTE_PATH)
  if (isViewSession) {
    if (!isViewRoute) {
      const newPath = `${VIEW_ROUTE_PATH}${path}`
      next({ path: newPath, params, query })
      return
    }
    next()
    return
  }

  if (isViewRoute) {
    const newPath = path.slice(VIEW_ROUTE_PATH.length)
    next({ path: newPath, params, query })
    return
  }

  next()
}
